export default __webpack_public_path__ + "static/media/mariekevlagKlein.efd3dca9.jpg";